import React from 'react';
import { Check } from 'lucide-react';
import { SectionStatus } from '../../utils/cadenceWizardNav';

export interface StepItem {
  number: number;
  title: string;
  status: SectionStatus;
  locked: boolean;
}

/** Horizontal stepper of bubbles across the top of the rule wizard.
 *  Presentational only — all navigation/save logic lives in the parent. */
const CadenceStepper: React.FC<{
  steps: StepItem[];
  active: number;
  onSelect: (n: number) => void;
}> = ({ steps, active, onSelect }) => (
  <div className="cadence-stepper" role="tablist" aria-label="Rule sections">
    {steps.map((s, i) => (
      <React.Fragment key={s.number}>
        {i > 0 && <span className="cadence-stepper-line" aria-hidden="true" />}
        <button
          type="button"
          role="tab"
          aria-selected={active === s.number}
          className={
            `cadence-stepper-step is-${s.status}` +
            (active === s.number ? ' is-active' : '') +
            (s.locked ? ' is-locked' : '')
          }
          data-testid={`STEP_cadence_${s.number}`}
          disabled={s.locked}
          onClick={() => onSelect(s.number)}
        >
          <span className="cadence-stepper-bubble">
            {s.status === 'saved' ? <Check size={14} /> : s.number}
          </span>
          <span className="cadence-stepper-title">{s.title}</span>
        </button>
      </React.Fragment>
    ))}
  </div>
);

export default CadenceStepper;
